import { render, staticRenderFns } from "./DoubleTableGroupingComponent.vue?vue&type=template&id=6629da8c&scoped=true"
import script from "./DoubleTableGroupingComponent.vue?vue&type=script&lang=js"
export * from "./DoubleTableGroupingComponent.vue?vue&type=script&lang=js"
import style0 from "./DoubleTableGroupingComponent.vue?vue&type=style&index=0&id=6629da8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629da8c",
  null
  
)

export default component.exports